import { useEffect, useRef } from 'react';
import { EVENTS as E } from '../constants';
import { useEventNameConstructor } from './useEventNameConstructor';
import { useSendEvents } from './useSendEvents';

export const useScreenEvents = (screenId: string) => {
  const sendEvents = useSendEvents({ screenId });
  const getEventName = useEventNameConstructor({ screenId });
  const initEventSentRef = useRef(false);

  useEffect(() => {
    if (initEventSentRef.current) return;
    sendEvents(getEventName(E.LOAD), { [E.SL]: screenId });
    initEventSentRef.current = true;
  }, [sendEvents, screenId, getEventName]);

  return { sendEvents, getEventName };
};
